import React, {
  lazy, Suspense, useEffect, useState,
} from 'react';
import PropTypes from 'prop-types';
import Title from '../../../components/title';

import {
  MainContainer,
  Container,
  CanvasContainer,
  Canvas,
  ImageLogo,
} from './style';

const CanvasLogo = lazy(() => import('../../../components/canvasLogo'));
const DEFER_3D_TIMEOUT_MS = 1800;
const INTERACTION_EVENTS = ['pointerdown', 'touchstart', 'keydown', 'scroll'];

function PresentationMobile({ contentScroll }) {
  const [enable3D, setEnable3D] = useState(false);

  useEffect(() => {
    let idleCallbackId;
    let timeoutId;

    const enableHero3D = () => {
      setEnable3D(true);
      INTERACTION_EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, enableHero3D);
      });
    };

    if ('requestIdleCallback' in window) {
      idleCallbackId = window.requestIdleCallback(enableHero3D, {
        timeout: DEFER_3D_TIMEOUT_MS,
      });
    } else {
      timeoutId = window.setTimeout(enableHero3D, DEFER_3D_TIMEOUT_MS);
    }

    INTERACTION_EVENTS.forEach((eventName) => {
      window.addEventListener(eventName, enableHero3D, { passive: true });
    });

    return () => {
      INTERACTION_EVENTS.forEach((eventName) => {
        window.removeEventListener(eventName, enableHero3D);
      });
      if (idleCallbackId) {
        window.cancelIdleCallback(idleCallbackId);
      }
      if (timeoutId) {
        window.clearTimeout(timeoutId);
      }
    };
  }, []);

  return (
    <MainContainer ref={contentScroll}>
      <Container>
        <CanvasContainer>
          <Canvas>
            {enable3D ? (
              <Suspense fallback={<ImageLogo forceVisible />}>
                <CanvasLogo mobile />
              </Suspense>
            ) : (
              <ImageLogo forceVisible />
            )}
          </Canvas>
        </CanvasContainer>
        <Title />
      </Container>
    </MainContainer>
  );
}

PresentationMobile.defaultProps = {
  contentScroll: null,
};

PresentationMobile.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  contentScroll: PropTypes.any,
};

export default PresentationMobile;
